import React, {useEffect, useState} from 'react'
import './ModalCustomerSessions.css'
import {format} from 'date-fns'

const ModalCustomerClients = ({closeModal, customerIdClients, customerInfo}) => {
    const [customerId, setCustomerId] = useState(customerIdClients);
    const [customerClients, setCustomerClients] = useState([]);
    const [errors, setErrors] = useState("")

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/clients/customer/' + customerId + '/view',
            {
                method: 'GET',
                headers: {
                    'machine':'2',
                    'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                },
            })
            .then(res => res.json())
            .then(data => {
                // const formattedOptions = data.map(item => ({ name: item.name, id: item.protocol_id }));
                setCustomerClients(data)
            })
            .catch(error => console.error(error));
        }, []);

    const validateForm = () => {

    }


    const handleSubmit = (e) => {
        e.preventDefault();
        closeModal();
    }

    return (
    <div className='modal-table' onClick={(e) => {
        if (e.target.className === "modal-table")
        closeModal()}}>
            <div className='modal-sessions'>
        <div className='table-wrapper'>
                <font size="1">
                <label>{customerInfo.customer_name} Clients ({customerClients.length})&emsp; Customer ID: {customerInfo.id} </label>
                <table className='table-sessions'>
                    <thead>
                        <tr>
                            <th className='center'>Client ID</th>
                            <th className='center'>Client Name</th>
                            <th className='center'>Client Since</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            customerClients.map((customerClient,i) => {
                                // const statusText = row.status.charAt(0).toUpperCase() + row.status.slice(1)
                                return <tr key={i}>
                                <td>{customerClient.id}</td>
                                <td>{customerClient.first_name} {customerClient.last_name}</td>
                                <td>{format(new Date(customerClient.created_on), 'MMM d, yyyy')}</td>
                               </tr>
                            })}

                    </tbody>
                </table>
                </font>


        <button type='submit' className='btn' onClick={handleSubmit}>Close</button>
        </div>
        </div>
    </div>
  )
}

export default ModalCustomerClients